<div class="right-config" id="right-config" [class.show]="navegacao.configAberta()">
    <div class="card">
        <div class="card-body">
            <div class="d-flex align-items-center justify-content-between">
                <h5 class="mt-2">Configurações</h5>
                <button class="btn btn-sm btn-light" type="button" (click)="navegacao.fecharConfig()">X</button>
            </div>
            <hr >
            <div class="row">
                <!--CONFIG LAYOUT-->
                <div class="col-md-12">
                    <h6 class="mb-3">Layout</h6>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="change_layout" id="change_layout_v" value="vertical"
                        (change)="navegacao.definirLayout('vertical')" [checked]="navegacao.layout() === 'vertical'">
                        <label class="form-check-label" for="change_layout_v">Vertical</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="change_layout" id="change_layout_h" value="horizontal"
                        (change)="navegacao.definirLayout('horizontal')" [checked]="navegacao.layout() === 'horizontal'">
                        <label class="form-check-label" for="change_layout_h">Horizontal</label>
                    </div>
                </div>

                <!--CONFIG SIDENAV FIXA-->
                @if (navegacao.layout() === 'vertical') {
                <div class="col-md-12">
                    <h6 class="mt-4 mb-3">Navegação Lateral</h6>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="change_viewSidenav" id="change_viewSidenav_0" value="estendida"
                        (change)="navegacao.definirSidenavRecolhida(false)" [checked]="!navegacao.sidenavRecolhida()">
                        <label class="form-check-label" for="change_viewSidenav_0">Estendida</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="change_viewSidenav" id="change_viewSidenav_1" value="reduzida"
                        (change)="navegacao.definirSidenavRecolhida(true)" [checked]="navegacao.sidenavRecolhida()">
                        <label class="form-check-label" for="change_viewSidenav_1">Reduzida</label>
                    </div>
                </div>
                }
                @else if (navegacao.layout() === 'horizontal') {
                <!--CONFIG TOPNAV FIXA-->
                <div class="col-md-12">
                    <h6 class="mt-4 mb-3">Navegação Superior</h6>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="change_viewTopnav" id="change_viewTopnav_0" value="oculta"
                        (change)="navegacao.definirSubnavVisivel(false)" [checked]="!navegacao.subnavVisivel()">
                        <label class="form-check-label" for="change_viewTopnav_0">Oculta</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="change_viewTopnav" id="change_viewTopnav_1" value="visivel"
                        (change)="navegacao.definirSubnavVisivel(true)" [checked]="navegacao.subnavVisivel()">
                        <label class="form-check-label" for="change_viewTopnav_1">Visível</label>
                    </div>
                </div>
                }

                <!--CONFIG THEMA-->
                <div class="col-md-12">
                    <h6 class="mt-4 mb-3">Tema</h6>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="change_tema" id="change_tema_l" value="light"
                        (change)="tema.definir('light')" [checked]="tema.tema() === 'light'">
                        <label class="form-check-label" for="change_tema_l">Claro</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="change_tema" id="change_tema_d" value="dark"
                        (change)="tema.definir('dark')" [checked]="tema.tema() === 'dark'">
                        <label class="form-check-label" for="change_tema_d">Escuro</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="change_tema" id="change_tema_s" value="sistema"
                        (change)="tema.definir('sistema')" [checked]="tema.tema() === 'sistema'">
                        <label class="form-check-label" for="change_tema_s">Sistema</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
